import { Control } from "react-hook-form";

export const clearFormControlCache = <FormType>(control: Control<FormType>) => {
  // @ts-ignore Это костыль, использовать в связке с useFieldArray.
  // Что бы избежать этот костыль необходим апдейт либ react-hook-form и yup
  // Пока что можно юзать это, для того что-бы правильно работал append/remove
  control.defaultValuesRef.current = {};
};
